module.exports = __webpack_public_path__ + "assets/c76fcc353e43069d5af81f74fc2453c5.jpg";